const hi = {
  nav: {
    home: "\u0939\u094b\u092e",
    browse: "\u0936\u093e\u0926\u093f\u092f\u093e\u0902 \u092c\u094d\u0930\u093e\u0909\u091c\u093c \u0915\u0930\u0947\u0902",
    browseWeddings: "\u0936\u093e\u0926\u093f\u092f\u093e\u0902 \u092c\u094d\u0930\u093e\u0909\u091c\u093c \u0915\u0930\u0947\u0902",
    dashboard: "\u0921\u0948\u0936\u092c\u094b\u0930\u094d\u0921",
    messages: "\u0938\u0902\u0926\u0947\u0936",
    profile: "\u092a\u094d\u0930\u094b\u092b\u093e\u0907\u0932",
    login: "\u0932\u0949\u0917\u093f\u0928",
    register: "\u0930\u091c\u093f\u0938\u094d\u091f\u0930",
    logout: "\u0932\u0949\u0917\u0906\u0909\u091f",
    admin: "\u090f\u0921\u092e\u093f\u0928",
  },
  landing: {
    hero: {
      badge: "#1 \u0936\u093e\u0926\u0940 \u0905\u0928\u0941\u092d\u0935 \u092e\u093e\u0930\u094d\u0915\u0947\u091f\u092a\u094d\u0932\u0947\u0938",
      title: "\u0926\u0941\u0928\u093f\u092f\u093e \u092d\u0930 \u092e\u0947\u0902 \u0905\u0935\u093f\u0938\u094d\u092e\u0930\u0923\u0940\u092f \u0936\u093e\u0926\u093f\u092f\u094b\u0902 \u0915\u093e \u0905\u0928\u0941\u092d\u0935 \u0915\u0930\u0947\u0902",
      subtitle: "WEDVAYA \u091c\u094b\u0921\u093c\u094b\u0902 \u0915\u094b \u092a\u094d\u0930\u093e\u092e\u093e\u0923\u093f\u0915 \u0938\u093e\u0902\u0938\u094d\u0915\u0943\u0924\u093f\u0915 \u0905\u0928\u0941\u092d\u0935 \u091a\u093e\u0939\u0928\u0947 \u0935\u093e\u0932\u0947 \u092f\u093e\u0924\u094d\u0930\u093f\u092f\u094b\u0902 \u0938\u0947 \u091c\u094b\u0921\u093c\u0924\u093e \u0939\u0948\u0964 \u090f\u0915 \u0935\u093f\u0936\u0947\u0937 \u092a\u0932 \u0915\u093e \u0939\u093f\u0938\u094d\u0938\u093e \u092c\u0928\u0947\u0902 \u2013 \u0939\u094b\u0938\u094d\u091f \u092f\u093e \u092e\u0947\u0939\u092e\u093e\u0928 \u0915\u0947 \u0930\u0942\u092a \u092e\u0947\u0902\u0964",
      cta_host: "\u0939\u094b\u0938\u094d\u091f \u0915\u0947 \u0930\u0942\u092a \u092e\u0947\u0902 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902",
      cta_guest: "\u0936\u093e\u0926\u093f\u092f\u093e\u0902 \u0916\u094b\u091c\u0947\u0902",
    },
    trust: {
      freeRegistration: "\u092e\u0941\u092b\u094d\u0924 \u092a\u0902\u091c\u0940\u0915\u0930\u0923",
      securePayment: "\u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u092d\u0941\u0917\u0924\u093e\u0928",
      gdprCompliant: "GDPR \u0905\u0928\u0941\u092a\u093e\u0932\u0928",
    },
    stats: {
      weddings: "\u0936\u093e\u0926\u093f\u092f\u093e\u0902",
      worldwide: "\u0926\u0941\u0928\u093f\u092f\u093e \u092d\u0930 \u092e\u0947\u0902",
      guests: "\u092e\u0947\u0939\u092e\u093e\u0928",
      matched: "\u091c\u0941\u0921\u093c\u0947",
      countries: "\u0926\u0947\u0936",
      represented: "\u092a\u094d\u0930\u0924\u093f\u0928\u093f\u0927\u093f\u0924\u094d\u0935",
      rating: "\u0930\u0947\u091f\u093f\u0902\u0917",
      average: "\u0914\u0938\u0924",
    },
    features: {
      title: "WEDVAYA \u0915\u094d\u092f\u094b\u0902?",
      subtitle: "\u0939\u092e \u0905\u0935\u093f\u0938\u094d\u092e\u0930\u0923\u0940\u092f \u0936\u093e\u0926\u0940 \u0915\u0947 \u0905\u0928\u0941\u092d\u0935\u094b\u0902 \u0915\u094b \u0938\u093e\u091d\u093e \u0915\u0930\u0928\u093e \u0906\u0938\u093e\u0928 \u0914\u0930 \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u092c\u0928\u093e\u0924\u0947 \u0939\u0948\u0902\u0964",
      secure: {
        title: "\u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u092d\u0941\u0917\u0924\u093e\u0928",
        desc: "\u0938\u092d\u0940 \u0932\u0947\u0928\u0926\u0947\u0928 Stripe \u0926\u094d\u0935\u093e\u0930\u093e \u0938\u0902\u0930\u0915\u094d\u0937\u093f\u0924 \u0939\u0948\u0902\u0964 \u0906\u092a\u0915\u093e \u092a\u0948\u0938\u093e \u0907\u0935\u0947\u0902\u091f \u0924\u0915 \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0939\u0948\u0964",
      },
      verified: {
        title: "\u0938\u0924\u094d\u092f\u093e\u092a\u093f\u0924 \u092a\u094d\u0930\u094b\u092b\u093e\u0907\u0932",
        desc: "\u0939\u094b\u0938\u094d\u091f \u0914\u0930 \u092e\u0947\u0939\u092e\u093e\u0928\u094b\u0902 \u0915\u0947 \u092c\u0940\u091a \u0935\u093f\u0936\u094d\u0935\u093e\u0938 \u0915\u0947 \u0932\u093f\u090f \u092a\u0939\u091a\u093e\u0928 \u0938\u0924\u094d\u092f\u093e\u092a\u0928\u0964",
      },
      global: {
        title: "\u0935\u0948\u0936\u094d\u0935\u093f\u0915 \u0915\u093e\u0930\u094d\u092f\u0915\u094d\u0930\u092e",
        desc: "\u091f\u0938\u094d\u0915\u0928\u0940 \u092e\u0947\u0902 \u0930\u094b\u092e\u093e\u0902\u091f\u093f\u0915 \u0936\u093e\u0926\u093f\u092f\u094b\u0902 \u0938\u0947 \u0932\u0947\u0915\u0930 \u092d\u093e\u0930\u0924 \u092e\u0947\u0902 \u092a\u093e\u0930\u0902\u092a\u0930\u093f\u0915 \u0938\u092e\u093e\u0930\u094b\u0939\u094b\u0902 \u0924\u0915\u0964",
      },
      contact: {
        title: "\u0938\u0940\u0927\u093e \u0938\u0902\u092a\u0930\u094d\u0915",
        desc: "\u092c\u0941\u0915\u093f\u0902\u0917 \u0915\u0947 \u092c\u093e\u0926\u060c \u0906\u092a \u0905\u092a\u0928\u0947 \u0939\u094b\u0938\u094d\u091f \u0938\u0947 \u0938\u0940\u0927\u0947 \u0938\u0902\u0935\u093e\u0926 \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964",
      },
      gdpr: {
        title: "GDPR \u0905\u0928\u0941\u092a\u093e\u0932\u0928",
        desc: "\u0906\u092a\u0915\u093e \u0921\u0947\u091f\u093e \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0939\u0948\u0964 \u0939\u092e \u092f\u0942\u0930\u094b\u092a\u0940\u092f \u0921\u0947\u091f\u093e \u0938\u0941\u0930\u0915\u094d\u0937\u093e \u0926\u093f\u0936\u093e\u0928\u093f\u0930\u094d\u0926\u0947\u0936\u094b\u0902 \u0915\u093e \u0938\u0916\u094d\u0924\u0940 \u0938\u0947 \u092a\u093e\u0932\u0928 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964",
      },
      instant: {
        title: "\u0924\u0941\u0930\u0902\u0924 \u092c\u0941\u0915\u093f\u0902\u0917",
        desc: "\u0924\u0947\u091c\u093c \u0906\u0935\u0947\u0926\u0928 \u092a\u094d\u0930\u0915\u094d\u0930\u093f\u092f\u093e\u0964 48 \u0918\u0902\u091f\u094b\u0902 \u0915\u0947 \u092d\u0940\u0924\u0930 \u091c\u0935\u093e\u092c \u092a\u094d\u0930\u093e\u092a\u094d\u0924 \u0915\u0930\u0947\u0902\u0964",
      },
    },
    howItWorks: {
      title: "\u092f\u0939 \u0915\u0948\u0938\u0947 \u0915\u093e\u092e \u0915\u0930\u0924\u093e \u0939\u0948",
      subtitle: "\u0905\u0935\u093f\u0938\u094d\u092e\u0930\u0923\u0940\u092f \u0905\u0928\u0941\u092d\u0935 \u0915\u0947 \u0932\u093f\u090f \u092c\u0938 \u0915\u0941\u091b \u0915\u0926\u092e",
      step1: {
        title: "\u0936\u093e\u0926\u0940 \u0916\u094b\u091c\u0947\u0902",
        desc: "\u0926\u0941\u0928\u093f\u092f\u093e \u092d\u0930 \u092e\u0947\u0902 \u0905\u0926\u094d\u0935\u093f\u0924\u0940\u092f \u0936\u093e\u0926\u093f\u092f\u094b\u0902 \u0915\u093e \u091a\u092f\u0928 \u092c\u094d\u0930\u093e\u0909\u091c\u093c \u0915\u0930\u0947\u0902\u0964",
      },
      step2: {
        title: "\u0906\u0935\u0947\u0926\u0928 \u092d\u0947\u091c\u0947\u0902",
        desc: "\u091c\u094b\u0921\u093c\u0947 \u0915\u094b \u0905\u092a\u0928\u093e \u092a\u0930\u093f\u091a\u092f \u0926\u0947\u0902 \u0914\u0930 \u092c\u0924\u093e\u090f\u0902 \u0915\u093f \u0906\u092a \u0915\u094d\u092f\u094b\u0902 \u0936\u093e\u092e\u093f\u0932 \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u0924\u0947 \u0939\u0948\u0902\u0964",
      },
      step3: {
        title: "\u092a\u0941\u0937\u094d\u091f\u093f \u0914\u0930 \u092d\u0941\u0917\u0924\u093e\u0928",
        desc: "\u092e\u0902\u091c\u0942\u0930\u0940 \u0915\u0947 \u092c\u093e\u0926\u060c \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0930\u0942\u092a \u0938\u0947 \u0911\u0928\u0932\u093e\u0907\u0928 \u092d\u0941\u0917\u0924\u093e\u0928 \u0915\u0930\u0947\u0902\u0964",
      },
      step4: {
        title: "\u091c\u0936\u094d\u0928 \u092e\u0928\u093e\u090f\u0902",
        desc: "\u090f\u0915 \u092a\u094d\u0930\u093e\u092e\u093e\u0923\u093f\u0915 \u0936\u093e\u0926\u0940 \u0915\u093e \u0905\u0928\u0941\u092d\u0935 \u0915\u0930\u0947\u0902 \u0914\u0930 \u0906\u091c\u0940\u0935\u0928 \u092f\u093e\u0926\u0947\u0902 \u092c\u0928\u093e\u090f\u0902\u0964",
      },
    },
    howItWorksHost: {
      step1: {
        title: "\u0905\u092a\u0928\u0940 \u0936\u093e\u0926\u0940 \u0938\u0942\u091a\u0940\u092c\u0926\u094d\u0927 \u0915\u0930\u0947\u0902",
        desc: "\u0938\u092d\u0940 \u092e\u0939\u0924\u094d\u0935\u092a\u0942\u0930\u094d\u0923 \u0935\u093f\u0935\u0930\u0923\u094b\u0902 \u0915\u0947 \u0938\u093e\u0925 \u0905\u092a\u0928\u0940 \u0936\u093e\u0926\u0940 \u0915\u0947 \u0932\u093f\u090f \u090f\u0915 \u092a\u094d\u0930\u094b\u092b\u093e\u0907\u0932 \u092c\u0928\u093e\u090f\u0902\u0964",
      },
      step2: {
        title: "\u0906\u0935\u0947\u0926\u0928\u094b\u0902 \u0915\u0940 \u0938\u092e\u0940\u0915\u094d\u0937\u093e \u0915\u0930\u0947\u0902",
        desc: "\u0907\u091a\u094d\u091b\u0941\u0915 \u092e\u0947\u0939\u092e\u093e\u0928\u094b\u0902 \u0915\u0940 \u092a\u094d\u0930\u094b\u092b\u093e\u0907\u0932 \u0926\u0947\u0916\u0947\u0902\u0964",
      },
      step3: {
        title: "\u092d\u0941\u0917\u0924\u093e\u0928 \u092a\u094d\u0930\u093e\u092a\u094d\u0924 \u0915\u0930\u0947\u0902",
        desc: "\u0907\u0935\u0947\u0902\u091f \u0915\u0947 \u092c\u093e\u0926\u060c \u0906\u092a\u0915\u094b \u0938\u094d\u0935\u091a\u093e\u0932\u093f\u0924 \u0930\u0942\u092a \u0938\u0947 85% \u0906\u092f \u092a\u094d\u0930\u093e\u092a\u094d\u0924 \u0939\u094b\u0924\u0940 \u0939\u0948\u0964",
      },
      step4: {
        title: "\u0938\u093e\u0925 \u092e\u093f\u0932\u0915\u0930 \u091c\u0936\u094d\u0928 \u092e\u0928\u093e\u090f\u0902",
        desc: "\u0926\u0941\u0928\u093f\u092f\u093e \u092d\u0930 \u0915\u0947 \u0932\u094b\u0917\u094b\u0902 \u0915\u0947 \u0938\u093e\u0925 \u0905\u092a\u0928\u093e \u0916\u093e\u0938 \u0926\u093f\u0928 \u0938\u093e\u091d\u093e \u0915\u0930\u0947\u0902\u0964",
      },
    },
    tabs: {
      forGuests: "\u092e\u0947\u0939\u092e\u093e\u0928\u094b\u0902 \u0915\u0947 \u0932\u093f\u090f",
      forHosts: "\u0939\u094b\u0938\u094d\u091f \u0915\u0947 \u0932\u093f\u090f",
    },
    testimonials: {
      title: "\u0939\u092e\u093e\u0930\u093e \u0938\u092e\u0941\u0926\u093e\u092f \u0915\u094d\u092f\u093e \u0915\u0939\u0924\u093e \u0939\u0948",
      subtitle: "\u0935\u093e\u0938\u094d\u0924\u0935\u093f\u0915 \u0932\u094b\u0917\u094b\u0902 \u0915\u0947 \u0935\u093e\u0938\u094d\u0924\u0935\u093f\u0915 \u0905\u0928\u0941\u092d\u0935",
    },
    featured: {
      title: "\u0935\u093f\u0936\u0947\u0937 \u0936\u093e\u0926\u093f\u092f\u093e\u0902",
      subtitle: "\u0926\u0941\u0928\u093f\u092f\u093e \u092d\u0930 \u092e\u0947\u0902 \u0905\u0926\u094d\u0935\u093f\u0924\u0940\u092f \u0938\u092e\u093e\u0930\u094b\u0939 \u0916\u094b\u091c\u0947\u0902",
      viewAll: "\u0938\u092d\u0940 \u0926\u0947\u0916\u0947\u0902",
      perPerson: "\u092a\u094d\u0930\u0924\u093f \u0935\u094d\u092f\u0915\u094d\u0924\u093f",
    },
    cta: {
      title: "\u0905\u092a\u0928\u0947 \u0905\u0935\u093f\u0938\u094d\u092e\u0930\u0923\u0940\u092f \u0905\u0928\u0941\u092d\u0935 \u0915\u0947 \u0932\u093f\u090f \u0924\u0948\u092f\u093e\u0930?",
      subtitle: "WEDVAYA \u0938\u092e\u0941\u0926\u093e\u092f \u0938\u0947 \u091c\u0941\u0921\u093c\u0947\u0902",
      description: "\u091a\u093e\u0939\u0947 \u0906\u092a \u0905\u092a\u0928\u0940 \u0936\u093e\u0926\u0940 \u0926\u0941\u0928\u093f\u092f\u093e \u0915\u0947 \u0938\u093e\u0925 \u0938\u093e\u091d\u093e \u0915\u0930\u0928\u093e \u091a\u093e\u0939\u0947\u0902 \u092f\u093e \u090f\u0915 \u0905\u0926\u094d\u0935\u093f\u0924\u0940\u092f \u092f\u093e\u0924\u094d\u0930\u093e \u0905\u0928\u0941\u092d\u0935 \u0916\u094b\u091c\u0947\u0902 \u2013 WEDVAYA \u0907\u0938\u0947 \u0938\u0902\u092d\u0935 \u092c\u0928\u093e\u0924\u093e \u0939\u0948\u0964",
      button: "\u092e\u0941\u092b\u094d\u0924 \u092e\u0947\u0902 \u092a\u0902\u091c\u0940\u0915\u0930\u0923 \u0915\u0930\u0947\u0902",
      becomeHost: "\u0905\u092d\u0940 \u0939\u094b\u0938\u094d\u091f \u092c\u0928\u0947\u0902",
      learnMore: "\u0914\u0930 \u091c\u093e\u0928\u0947\u0902",
    },
    press: {
      title: "\u092e\u0940\u0921\u093f\u092f\u093e \u092e\u0947\u0902",
    },
  },
  auth: {
    login: {
      title: "\u0935\u093e\u092a\u0938\u0940 \u092a\u0930 \u0938\u094d\u0935\u093e\u0917\u0924 \u0939\u0948",
      email: "\u0908\u092e\u0947\u0932",
      password: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921",
      button: "\u0932\u0949\u0917\u093f\u0928",
      noAccount: "\u0916\u093e\u0924\u093e \u0928\u0939\u0940\u0902 \u0939\u0948?",
      register: "\u0905\u092d\u0940 \u0930\u091c\u093f\u0938\u094d\u091f\u0930 \u0915\u0930\u0947\u0902",
      forgotPassword: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u092d\u0942\u0932 \u0917\u090f?",
    },
    register: {
      title: "\u0916\u093e\u0924\u093e \u092c\u0928\u093e\u090f\u0902",
      name: "\u092a\u0942\u0930\u093e \u0928\u093e\u092e",
      email: "\u0908\u092e\u0947\u0932",
      password: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921",
      role: "\u092e\u0948\u0902 \u091a\u093e\u0939\u0924\u093e \u0939\u0942\u0902...",
      roleHost: "\u0936\u093e\u0926\u0940 \u0915\u0940 \u092e\u0947\u091c\u092c\u093e\u0928\u0940 \u0915\u0930\u0928\u093e",
      roleGuest: "\u0936\u093e\u0926\u093f\u092f\u094b\u0902 \u092e\u0947\u0902 \u0936\u093e\u092e\u093f\u0932 \u0939\u094b\u0928\u093e",
      terms: "\u092e\u0948\u0902 \u0928\u093f\u092f\u092e \u0914\u0930 \u0917\u094b\u092a\u0928\u0940\u092f\u0924\u093e \u0928\u0940\u0924\u093f \u0938\u094d\u0935\u0940\u0915\u093e\u0930 \u0915\u0930\u0924\u093e \u0939\u0942\u0902",
      button: "\u0930\u091c\u093f\u0938\u094d\u091f\u0930",
      hasAccount: "\u092a\u0939\u0932\u0947 \u0938\u0947 \u0916\u093e\u0924\u093e \u0939\u0948?",
      login: "\u0905\u092d\u0940 \u0932\u0949\u0917\u093f\u0928 \u0915\u0930\u0947\u0902",
    },
    forgotPassword: {
      title: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u092d\u0942\u0932 \u0917\u090f?",
      description: "\u0905\u092a\u0928\u093e \u0908\u092e\u0947\u0932 \u0926\u0930\u094d\u091c \u0915\u0930\u0947\u0902 \u0914\u0930 \u0939\u092e \u0906\u092a\u0915\u094b \u0930\u0940\u0938\u0947\u091f \u0932\u093f\u0902\u0915 \u092d\u0947\u091c\u0947\u0902\u0917\u0947",
      submit: "\u0932\u093f\u0902\u0915 \u092d\u0947\u091c\u0947\u0902",
      sent: "\u0905\u092a\u0928\u093e \u0908\u092e\u0947\u0932 \u091c\u093e\u0902\u091a\u0947\u0902",
      sentDescription: "\u092f\u0926\u093f \u0907\u0938 \u0908\u092e\u0947\u0932 \u0938\u0947 \u0915\u094b\u0908 \u0916\u093e\u0924\u093e \u0939\u0948, \u0924\u094b \u0906\u092a\u0915\u094b \u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0930\u0940\u0938\u0947\u091f \u0932\u093f\u0902\u0915 \u092a\u094d\u0930\u093e\u092a\u094d\u0924 \u0939\u094b\u0917\u093e\u0964",
      backToLogin: "\u0932\u0949\u0917\u093f\u0928 \u092a\u0930 \u0935\u093e\u092a\u0938 \u091c\u093e\u090f\u0902",
    },
    resetPassword: {
      title: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0930\u0940\u0938\u0947\u091f \u0915\u0930\u0947\u0902",
      description: "\u0905\u092a\u0928\u093e \u0928\u092f\u093e \u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0926\u0930\u094d\u091c \u0915\u0930\u0947\u0902",
      newPassword: "\u0928\u092f\u093e \u092a\u093e\u0938\u0935\u0930\u094d\u0921",
      confirmPassword: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0915\u0940 \u092a\u0941\u0937\u094d\u091f\u093f \u0915\u0930\u0947\u0902",
      submit: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0930\u0940\u0938\u0947\u091f \u0915\u0930\u0947\u0902",
      success: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0930\u0940\u0938\u0947\u091f \u0939\u094b \u0917\u092f\u093e!",
      successDesc: "\u0906\u092a\u0915\u093e \u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0930\u0942\u092a \u0938\u0947 \u0930\u0940\u0938\u0947\u091f \u0939\u094b \u0917\u092f\u093e \u0939\u0948\u0964 \u0905\u092c \u0906\u092a \u0932\u0949\u0917\u093f\u0928 \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964",
      goToLogin: "\u0932\u0949\u0917\u093f\u0928 \u092a\u0930 \u091c\u093e\u090f\u0902",
      mismatch: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u092e\u0947\u0932 \u0928\u0939\u0940\u0902 \u0916\u093e\u0924\u0947",
      tooShort: "\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0915\u092e \u0938\u0947 \u0915\u092e 6 \u0905\u0915\u094d\u0937\u0930 \u0915\u093e \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f",
    },
    verification: {
      verifying: "\u0906\u092a\u0915\u093e \u0908\u092e\u0947\u0932 \u0938\u0924\u094d\u092f\u093e\u092a\u093f\u0924 \u0939\u094b \u0930\u0939\u093e \u0939\u0948...",
      pleaseWait: "\u0915\u0943\u092a\u092f\u093e \u092a\u094d\u0930\u0924\u0940\u0915\u094d\u0937\u093e \u0915\u0930\u0947\u0902",
      successTitle: "\u0908\u092e\u0947\u0932 \u0938\u0924\u094d\u092f\u093e\u092a\u093f\u0924!",
      success: "\u0906\u092a\u0915\u093e \u0908\u092e\u0947\u0932 \u0938\u092b\u0932\u0924\u093e\u092a\u0942\u0930\u094d\u0935\u0915 \u0938\u0924\u094d\u092f\u093e\u092a\u093f\u0924 \u0939\u094b \u0917\u092f\u093e!",
      errorTitle: "\u0938\u0924\u094d\u092f\u093e\u092a\u0928 \u0935\u093f\u092b\u0932",
      noToken: "\u0915\u094b\u0908 \u0938\u0924\u094d\u092f\u093e\u092a\u0928 \u091f\u094b\u0915\u0928 \u0928\u0939\u0940\u0902 \u092e\u093f\u0932\u093e",
      goToLogin: "\u0932\u0949\u0917\u093f\u0928 \u092a\u0930 \u091c\u093e\u090f\u0902",
      tryAgain: "\u092b\u093f\u0930 \u0938\u0947 \u0930\u091c\u093f\u0938\u094d\u091f\u0930 \u0915\u0930\u0947\u0902",
    },
  },
  dashboard: {
    host: {
      title: "\u0939\u094b\u0938\u094d\u091f \u0921\u0948\u0936\u092c\u094b\u0930\u094d\u0921",
      myWeddings: "\u092e\u0947\u0930\u0940 \u0936\u093e\u0926\u093f\u092f\u093e\u0902",
      applications: "\u0906\u0935\u0947\u0926\u0928",
      earnings: "\u0915\u092e\u093e\u0908",
      messages: "\u0938\u0902\u0926\u0947\u0936",
      createWedding: "\u0936\u093e\u0926\u0940 \u092c\u0928\u093e\u090f\u0902",
      noWeddings: "\u0905\u092d\u0940 \u0924\u0915 \u0915\u094b\u0908 \u0936\u093e\u0926\u0940 \u0928\u0939\u0940\u0902 \u092c\u0928\u093e\u0908",
    },
    guest: {
      title: "\u0917\u0947\u0938\u094d\u091f \u0921\u0948\u0936\u092c\u094b\u0930\u094d\u0921",
      myApplications: "\u092e\u0947\u0930\u0947 \u0906\u0935\u0947\u0926\u0928",
      browseWeddings: "\u0936\u093e\u0926\u093f\u092f\u093e\u0902 \u092c\u094d\u0930\u093e\u0909\u091c\u093c \u0915\u0930\u0947\u0902",
      messages: "\u0938\u0902\u0926\u0947\u0936",
      profile: "\u092e\u0947\u0930\u0940 \u092a\u094d\u0930\u094b\u092b\u093e\u0907\u0932",
    },
  },
  wedding: {
    search: {
      title: "\u0936\u093e\u0926\u093f\u092f\u093e\u0902 \u0916\u094b\u091c\u0947\u0902",
      location: "\u0938\u094d\u0925\u093e\u0928",
      date: "\u0924\u093e\u0930\u0940\u0916",
      price: "\u0915\u0940\u092e\u0924",
      search: "\u0916\u094b\u091c\u0947\u0902",
      reset: "\u0930\u0940\u0938\u0947\u091f",
      noResults: "\u0915\u094b\u0908 \u0936\u093e\u0926\u0940 \u0928\u0939\u0940\u0902 \u092e\u093f\u0932\u0940",
    },
    card: {
      slots: "\u0938\u094d\u0932\u0949\u091f \u0909\u092a\u0932\u092c\u094d\u0927",
      perGuest: "\u092a\u094d\u0930\u0924\u093f \u092e\u0947\u0939\u092e\u093e\u0928",
      apply: "\u0906\u0935\u0947\u0926\u0928 \u0915\u0930\u0947\u0902",
      viewDetails: "\u0935\u093f\u0935\u0930\u0923 \u0926\u0947\u0916\u0947\u0902",
    },
    detail: {
      about: "\u0907\u0938 \u0936\u093e\u0926\u0940 \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902",
      host: "\u0939\u094b\u0938\u094d\u091f",
      location: "\u0938\u094d\u0925\u093e\u0928",
      date: "\u0924\u093e\u0930\u0940\u0916",
      dresscode: "\u0921\u094d\u0930\u0947\u0938 \u0915\u094b\u0921",
      price: "\u092a\u094d\u0930\u0924\u093f \u092e\u0947\u0939\u092e\u093e\u0928 \u0915\u0940\u092e\u0924",
      slots: "\u0909\u092a\u0932\u092c\u094d\u0927 \u0938\u094d\u0932\u0949\u091f",
      apply: "\u0905\u092d\u0940 \u0906\u0935\u0947\u0926\u0928 \u0915\u0930\u0947\u0902",
      alreadyApplied: "\u092a\u0939\u0932\u0947 \u0938\u0947 \u0906\u0935\u0947\u0926\u0928 \u0915\u093f\u092f\u093e",
    },
    create: {
      title: "\u0928\u0908 \u0936\u093e\u0926\u0940 \u092c\u0928\u093e\u090f\u0902",
      titleField: "\u0936\u0940\u0930\u094d\u0937\u0915",
      description: "\u0935\u093f\u0935\u0930\u0923",
      location: "\u0938\u094d\u0925\u093e\u0928",
      country: "\u0926\u0947\u0936",
      date: "\u0924\u093e\u0930\u0940\u0916",
      dresscode: "\u0921\u094d\u0930\u0947\u0938 \u0915\u094b\u0921",
      price: "\u092a\u094d\u0930\u0924\u093f \u092e\u0947\u0939\u092e\u093e\u0928 \u0915\u0940\u092e\u0924",
      slots: "\u092e\u0947\u0939\u092e\u093e\u0928\u094b\u0902 \u0915\u0940 \u0938\u0902\u0916\u094d\u092f\u093e",
      currency: "\u092e\u0941\u0926\u094d\u0930\u093e",
      submit: "\u0936\u093e\u0926\u0940 \u092c\u0928\u093e\u090f\u0902",
    },
  },
  application: {
    status: {
      pending: "\u0932\u0902\u092c\u093f\u0924",
      approved: "\u0938\u094d\u0935\u0940\u0915\u0943\u0924",
      rejected: "\u0905\u0938\u094d\u0935\u0940\u0915\u0943\u0924",
    },
    payment: {
      pending: "\u092d\u0941\u0917\u0924\u093e\u0928 \u0932\u0902\u092c\u093f\u0924",
      paid: "\u092d\u0941\u0917\u0924\u093e\u0928 \u0915\u093f\u092f\u093e \u0917\u092f\u093e",
      pay: "\u0905\u092d\u0940 \u092d\u0941\u0917\u0924\u093e\u0928 \u0915\u0930\u0947\u0902",
    },
    approve: "\u0938\u094d\u0935\u0940\u0915\u0943\u0924 \u0915\u0930\u0947\u0902",
    reject: "\u0905\u0938\u094d\u0935\u0940\u0915\u093e\u0930 \u0915\u0930\u0947\u0902",
  },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

  messages: {
    title: "\u0938\u0902\u0926\u0947\u0936",
    noMessages: "\u0915\u094b\u0908 \u0938\u0902\u0926\u0947\u0936 \u0928\u0939\u0940\u0902",
    placeholder: "\u0938\u0902\u0926\u0947\u0936 \u0932\u093f\u0916\u0947\u0902...",
    send: "\u092d\u0947\u091c\u0947\u0902",
  },
  admin: {
    title: "\u090f\u0921\u092e\u093f\u0928 \u0921\u0948\u0936\u092c\u094b\u0930\u094d\u0921",
    stats: {
      users: "\u0909\u092a\u092f\u094b\u0917\u0915\u0930\u094d\u0924\u093e",
      hosts: "\u0939\u094b\u0938\u094d\u091f",
      guests: "\u092e\u0947\u0939\u092e\u093e\u0928",
      weddings: "\u0936\u093e\u0926\u093f\u092f\u093e\u0902",
      activeWeddings: "\u0938\u0915\u094d\u0930\u093f\u092f \u0936\u093e\u0926\u093f\u092f\u093e\u0902",
      applications: "\u0906\u0935\u0947\u0926\u0928",
      revenue: "\u0915\u0941\u0932 \u0930\u093e\u091c\u0938\u094d\u0935",
      platformEarnings: "\u092a\u094d\u0932\u0947\u091f\u092b\u0949\u0930\u094d\u092e \u0915\u092e\u093e\u0908",
    },
    tabs: {
      overview: "\u0905\u0935\u0932\u094b\u0915\u0928",
      users: "\u0909\u092a\u092f\u094b\u0917\u0915\u0930\u094d\u0924\u093e",
      weddings: "\u0936\u093e\u0926\u093f\u092f\u093e\u0902",
      transactions: "\u0932\u0947\u0928\u0926\u0947\u0928",
    },
    actions: {
      ban: "\u092a\u094d\u0930\u0924\u093f\u092c\u0902\u0927",
      unban: "\u092a\u094d\u0930\u0924\u093f\u092c\u0902\u0927 \u0939\u091f\u093e\u090f\u0902",
      feature: "\u092b\u0940\u091a\u0930",
      unfeature: "\u092b\u0940\u091a\u0930 \u0939\u091f\u093e\u090f\u0902",
    },
  },
  common: {
    loading: "\u0932\u094b\u0921 \u0939\u094b \u0930\u0939\u093e \u0939\u0948...",
    error: "\u090f\u0915 \u0924\u094d\u0930\u0941\u091f\u093f \u0939\u0941\u0908",
    success: "\u0938\u092b\u0932\u0924\u093e",
    save: "\u0938\u0939\u0947\u091c\u0947\u0902",
    cancel: "\u0930\u0926\u094d\u0926 \u0915\u0930\u0947\u0902",
    delete: "\u0939\u091f\u093e\u090f\u0902",
    edit: "\u0938\u0902\u092a\u093e\u0926\u093f\u0924 \u0915\u0930\u0947\u0902",
    back: "\u0935\u093e\u092a\u0938",
    next: "\u0905\u0917\u0932\u093e",
    language: "\u092d\u093e\u0937\u093e",
    currency: "\u092e\u0941\u0926\u094d\u0930\u093e",
  },
  footer: {
    about: "\u0939\u092e\u093e\u0930\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902",
    privacy: "\u0917\u094b\u092a\u0928\u0940\u092f\u0924\u093e",
    terms: "\u0936\u0930\u094d\u0924\u0947\u0902",
    contact: "\u0938\u0902\u092a\u0930\u094d\u0915",
    description: "\u0905\u0935\u093f\u0938\u094d\u092e\u0930\u0923\u0940\u092f \u0936\u093e\u0926\u0940 \u0905\u0928\u0941\u092d\u0935\u094b\u0902 \u0915\u0947 \u0932\u093f\u090f \u0935\u0948\u0936\u094d\u0935\u093f\u0915 \u092e\u0902\u091a\u0964",
    copyright: "\u00a9 2024 WEDVAYA. \u0938\u0930\u094d\u0935\u093e\u0927\u093f\u0915\u093e\u0930 \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924\u0964",
  },
  notifications: {
    title: "\u0938\u0942\u091a\u0928\u093e\u090f\u0902",
    empty: "\u0905\u092d\u0940 \u0924\u0915 \u0915\u094b\u0908 \u0938\u0942\u091a\u0928\u093e \u0928\u0939\u0940\u0902",
    markAllRead: "\u0938\u092d\u0940 \u0915\u094b \u092a\u0922\u093c\u093e \u0939\u0941\u0906 \u091a\u093f\u0939\u094d\u0928\u093f\u0924 \u0915\u0930\u0947\u0902",
  },
  chat: {
    conversations: "\u092c\u093e\u0924\u091a\u0940\u0924",
    search: "\u092c\u093e\u0924\u091a\u0940\u0924 \u0916\u094b\u091c\u0947\u0902...",
    noConversations: "\u0905\u092d\u0940 \u0924\u0915 \u0915\u094b\u0908 \u092c\u093e\u0924\u091a\u0940\u0924 \u0928\u0939\u0940\u0902",
    selectConversation: "\u092c\u093e\u0924\u091a\u0940\u0924 \u091a\u0941\u0928\u0947\u0902",
    selectConversationDesc: "\u091a\u0948\u091f \u0936\u0941\u0930\u0942 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0938\u0942\u091a\u0940 \u0938\u0947 \u092c\u093e\u0924\u091a\u0940\u0924 \u091a\u0941\u0928\u0947\u0902",
    online: "\u0911\u0928\u0932\u093e\u0907\u0928",
    offline: "\u0911\u092b\u0932\u093e\u0907\u0928",
    connecting: "\u0915\u0928\u0947\u0915\u094d\u091f \u0939\u094b \u0930\u0939\u093e \u0939\u0948...",
    noMessages: "\u0905\u092d\u0940 \u0924\u0915 \u0915\u094b\u0908 \u0938\u0902\u0926\u0947\u0936 \u0928\u0939\u0940\u0902",
    startConversation: "\u092c\u093e\u0924\u091a\u0940\u0924 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902!",
    placeholder: "\u0938\u0902\u0926\u0947\u0936 \u091f\u093e\u0907\u092a \u0915\u0930\u0947\u0902...",
    you: "\u0906\u092a",
  },
  cookies: {
    title: "\u0939\u092e \u0915\u0941\u0915\u0940\u091c\u093c \u0915\u093e \u0909\u092a\u092f\u094b\u0917 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902",
    description: "\u0939\u092e \u0906\u092a\u0915\u0947 \u0905\u0928\u0941\u092d\u0935 \u0915\u094b \u092c\u0947\u0939\u0924\u0930 \u092c\u0928\u093e\u0928\u0947, \u091f\u094d\u0930\u0948\u092b\u093c\u093f\u0915 \u0915\u093e \u0935\u093f\u0936\u094d\u0932\u0947\u0937\u0923 \u0915\u0930\u0928\u0947 \u0914\u0930 \u092e\u093e\u0930\u094d\u0915\u0947\u091f\u093f\u0902\u0917 \u0909\u0926\u094d\u0926\u0947\u0936\u094d\u092f\u094b\u0902 \u0915\u0947 \u0932\u093f\u090f \u0915\u0941\u0915\u0940\u091c\u093c \u0915\u093e \u0909\u092a\u092f\u094b\u0917 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964",
    acceptAll: "\u0938\u092d\u0940 \u0938\u094d\u0935\u0940\u0915\u093e\u0930\u0947\u0902",
    rejectAll: "\u0938\u092d\u0940 \u0905\u0938\u094d\u0935\u0940\u0915\u093e\u0930 \u0915\u0930\u0947\u0902",
    customize: "\u0905\u0928\u0941\u0915\u0942\u0932\u093f\u0924 \u0915\u0930\u0947\u0902",
    settingsTitle: "\u0915\u0941\u0915\u0940 \u0938\u0947\u091f\u093f\u0902\u0917\u094d\u0938",
    functional: "\u0915\u093e\u0930\u094d\u092f\u093e\u0924\u094d\u092e\u0915 \u0915\u0941\u0915\u0940\u091c\u093c",
    functionalDesc: "\u0935\u0947\u092c\u0938\u093e\u0907\u091f \u0915\u0947 \u0920\u0940\u0915 \u0938\u0947 \u0915\u093e\u092e \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0906\u0935\u0936\u094d\u092f\u0915\u0964",
    analytics: "\u090f\u0928\u093e\u0932\u093f\u091f\u093f\u0915\u094d\u0938 \u0915\u0941\u0915\u0940\u091c\u093c",
    analyticsDesc: "\u0939\u092e\u0947\u0902 \u092f\u0939 \u0938\u092e\u091d\u0928\u0947 \u092e\u0947\u0902 \u092e\u0926\u0926 \u0915\u0930\u0924\u0940 \u0939\u0948\u0902 \u0915\u093f \u0906\u0917\u0902\u0924\u0941\u0915 \u0935\u0947\u092c\u0938\u093e\u0907\u091f \u0915\u0947 \u0938\u093e\u0925 \u0915\u0948\u0938\u0947 \u0907\u0902\u091f\u0930\u0948\u0915\u094d\u091f \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964",
    marketing: "\u092e\u093e\u0930\u094d\u0915\u0947\u091f\u093f\u0902\u0917 \u0915\u0941\u0915\u0940\u091c\u093c",
    marketingDesc: "\u0935\u094d\u092f\u0915\u094d\u0924\u093f\u0917\u0924 \u0935\u093f\u091c\u094d\u091e\u093e\u092a\u0928 \u0926\u093f\u0916\u093e\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0909\u092a\u092f\u094b\u0917 \u0915\u0940 \u091c\u093e\u0924\u0940 \u0939\u0948\u0902\u0964",
    saveSettings: "\u0938\u0947\u091f\u093f\u0902\u0917\u094d\u0938 \u0938\u0939\u0947\u091c\u0947\u0902",
  },
};

export default hi;
